import {store} from './redux/store';
import {defaultProjectTitle, changeName, changePath, currentConfigVersion} from './redux/project-slice';
import {dialog, fs, app, isStaticSite, ipcRenderer} from './electron-modules';
import slash from 'slash';
import path from 'path';
import {isEqual} from 'lodash';

export const projectFileType = "json";
const filterFilter = [{name: 'Engine Viewer Projects', extensions: [projectFileType]}];

export const saveProjectAs = () => {
  return dialog.showSaveDialog({
    title: "Save Project",
    defaultPath: `${store.getState().project.name}.json`,
    filters: filterFilter,
  }).then((result) => {
    if (result.canceled) {
      return false;
    }

    const savePath = slash(result.filePath);
    store.dispatch(changePath(savePath));
    // update the title of the project to the filename
    if (store.getState().project.name === defaultProjectTitle) {
      // get filename from path
      const fileName = path.basename(savePath);
      const extension = path.extname(savePath);
      const nameWithoutExt = path.basename(fileName, extension);
      store.dispatch(changeName(nameWithoutExt));
    }

    const state = store.getState();
    writeProject(state);
    return true;
  }).catch(() => {
    dialog.showErrorBox('Error saving project', 'An error occurred while saving the project.');
    return false;
  });
};

export const saveProject = (allowSaveAs = true) => {
  return new Promise(resolve => {
    const state = store.getState();

    if (state.project.path === '') {
      if (allowSaveAs) {
        saveProjectAs().then(result => {
          resolve(result);
        });
      }
      return;
    } else {
      writeProject(state);
      resolve(true);
    }
  });
};

export const loadProjectJSON = (data) => {
  const projectJSON = JSON.parse(data);

  store.dispatch({
    type: 'LOAD',
    payload: projectJSON
  });
};

export const loadProjectFile = (filePath) => {
  try {
    const data = fs.readFileSync(filePath, 'utf8');

    // Update json path based on where the json was loaded from
    let projectJSON = JSON.parse(data);
    projectJSON.project.path = filePath;

    const jsonConfigVersion = projectJSON.project.configVersion;

    // Update the loadJSON state
    projectJSON.assets.forEach((asset, index) => {
      projectJSON.assets[index].fromJSON = true;
    });

    if (jsonConfigVersion !== currentConfigVersion) {
      const versionOld = (jsonConfigVersion % 1.0 === 0.0)
        ? jsonConfigVersion.toFixed(1)
        : jsonConfigVersion;

      const versionNew = (currentConfigVersion % 1.0 === 0.0)
        ? currentConfigVersion.toFixed(1)
        : currentConfigVersion;

      alert(`Invalid config version (${versionOld}). Latest version is ${versionNew}`);
      return false;
    }

    const projectString = JSON.stringify(projectJSON);
    loadProjectJSON(projectString);
    return true;
  } catch (err) {
    alert('Error loading project');
    return false;
  }
};

export const loadProject = () => {
  dialog.showOpenDialog({
    properties: ['openFile'],
    filters: filterFilter
  }).then(result => {
    if (result.canceled) {
      return;
    }

    const filePath = slash(result.filePaths[0]);
    loadProjectFile(filePath);
  }).catch(error => {
    console.log(error);
  });
};

export const newProject = () => {
  dialog.showMessageBox({
    type: 'question',
    title: 'Create new project?',
    message: 'Any unsaved changes to your current project will be lost.',
    buttons: ['Cancel', 'Create new project'],
    noLink: true
  }).then(result => {
    if (result.response === 0) {
      return;
    }

    store.dispatch({type: 'NEW'});
  });
};

const writeProject = (state) => {
  const name = state.project.path;
  const string = JSON.stringify(state, null, 2);

  fs.writeFile(name, string, (err) => {
    if (err) {
      throw Error('an error occurred while saving the project');
    }
  });
};

if (!isStaticSite) {
  ipcRenderer.on("save-project", () => {
    const state = store.getState();

    if (state.project.path !== "") {
      const data = fs.readFileSync(state.project.path, "utf8");
      let projectJSON = JSON.parse(data);
      projectJSON.project.modified = state.project.modified;
    }

    saveProject().then((saved) => {

      if (saved) {
        app.exit();
      }
    });
  });

  ipcRenderer.on("project-changed", () => {
    const state = store.getState();
    let hasChanged;

    if (state.project.path !== "") {
      // Compare current state to saved json state
      const data = fs.readFileSync(state.project.path, "utf8");
      let projectJSON = JSON.parse(data);
      projectJSON.project.modified = state.project.modified;
      hasChanged = !isEqual(state, projectJSON);
    } else {
      // Dont prompt user unless assets are loaded
      hasChanged = state.assets.length !== 0;
    }

    ipcRenderer.send('should-save', hasChanged);
  });
}
